import styled from 'styled-components'
import { dimensions, light, spacing } from '~/constants/theme'
import { colors } from '~/styles'

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

export const SubtitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

export const SupportLinkWrapper = styled.span``

export const SupportLink = styled.span`
  margin-left: 5px;
  font-family: 'Inter', Helvetica, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 114.9%;
  color: ${light.orange100};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`

export const HeaderSidebarContainer = styled.header`
  padding: ${spacing.spacingXL};
  padding-bottom: 0;
  background-color: ${light.gray200};
`

export const SharedVMWrapper = styled.div`
  margin-right: ${spacing.spacingSM};
  padding: 0;
`

export const NotificationWrapper = styled.div`
  width: 100%;
  height: 28px;
  margin-top: -16px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  background-color: ${light.gray200};
  box-sizing: border-box;
  cursor: pointer;
`

export const RootWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: ${spacing.spacingXL};
  box-sizing: border-box;
  background: ${light.gray300};
`

export const Wrapper = styled.div`
  padding: ${spacing.spacingXL};
  box-sizing: border-box;
  border-radius: ${dimensions.borderRadiusSM};
  background-color: ${light.gray100};
`

export const DateWrapper = styled.div`
  width: 100%;
  height: 20px;
  margin-bottom: ${spacing.spacingSM};
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const PlayerLoadingWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

export const TranscriptWrapper = styled.div`
  margin: 0 -16px;
`

export const TranscriptLabelWrapper = styled.div`
  padding: ${spacing.spacingXL} ${spacing.spacingXL} ${spacing.spacingSM}
    ${spacing.spacingXL};
  border-bottom: 2px solid ${light.gray300};
`

export const TranscriptContentWrapper = styled.div`
  padding: ${spacing.spacingXL} ${spacing.spacingXL} 0 ${spacing.spacingXL};
`

export const ButtonsWrapper = styled.div`
  width: 100%;
  margin: ${spacing.spacingXL} 0 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const RightButtonWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const MangoPlusBannerWrapper = styled.div`
  height: 46px;
  padding: 0 20px;
  margin: 0 -20px -20px -20px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  background-color: ${colors.gray3};
`

export const LearnMoreButton = styled.div`
  padding-left: 5px;
  cursor: pointer;
  p {
    text-decoration: underline;
  }
`
